import { Form, Loading } from '@ampol/design-system';
import CardModal from '../CardModal';
import CardModalAccount from '../CardModalAccount';
import { MULTI_EDIT_CARD_MODAL_FORM_ID } from './useMultiEditCardModal';
import {
  useSelectCardDetails,
  useSelectCardDetailsLoading,
} from 'selectors/selectors';
import { useDispatch, useSelector } from 'react-redux';
import {
  incrementMultiEditIndex,
  setCurrentMultiEditFormValues,
  useSelectMultiEditCardCurrentValues,
  useSelectMultiEditCardFormValues,
  useSelectMultiEditCardOriginalValues,
  useSelectMultiEditCardsLength,
  useSelectMultiEditCardStatus,
  useSelectMutliEditCardIndex,
} from './MutliEditCardFormSlice';
import useCardModalController from '../useCardModalController';
import { useEffect } from 'react';
import useEditCardFormController from '../edit-card-modal/useEditCardFormController';
import useMultiEditConfirmModal from './useMultiEditConfirmModal';
import { trackCustomEvent } from 'utilities/app-insights';
import { RootState } from 'reducers';
import {
  getAddEditCardRequest,
  getFleetLimiterCodesObj,
} from 'features/cards/helpers/add-edit-card-helper';
import _ from 'lodash';
import { editMultipleCardDetails } from 'actions/cardActions';

function MultiEditCardModalContent() {
  const dispatch = useDispatch();
  const isLoadingDetails = useSelectCardDetailsLoading();
  const currentFormValues = useSelectMultiEditCardCurrentValues();
  const formValues = useSelectMultiEditCardFormValues();
  const index = useSelectMutliEditCardIndex();
  const totalCards = useSelectMultiEditCardsLength();
  const cardStatus = useSelectMultiEditCardStatus();
  const mutliEditConfirmModal = useMultiEditConfirmModal(onConfirmSubmit);
  const loggedInUser = useSelector(
    (state: RootState) => state.userStore.loggedInUser
  );
  const assignedAccountNumber = useSelector(
    (state: RootState) => state.userStore.assignedAccountNumber
  );
  const userStore = useSelector((state: RootState) => state.userStore);
  const grandParentAccountNumber = userStore.assignedGrandfatherClientNumber;
  const { fleetLimiters } = useSelectCardDetails() || {};
  const originalFormValues = useSelectMultiEditCardOriginalValues();
  const controller = useCardModalController();
  useEditCardFormController(() => {});

  function onConfirmSubmit() {
    // Copied similar logic from edit-multiple-card-wrapper.js handleCardChange
    const formattedFormValues = formValues.map((formValue, index) => {
      const originalValue = originalFormValues[index];
      const isModified = !_.isEqual(formValue, originalValue);
      const req = getAddEditCardRequest(
        {
          ...formValue,
          ...getFleetLimiterCodesObj(fleetLimiters),
        },
        fleetLimiters,
        grandParentAccountNumber
      );

      return {
        ...req,
        isModified,
      };
    });

    const request = {
      cardStatus,
      cards: formattedFormValues,
      grandParentAccountNumber,
    };

    if (request.cards && request.cards.length > 0) {
      dispatch(editMultipleCardDetails(request, grandParentAccountNumber));

      trackCustomEvent(
        'Submit Edit Card and Update Status',
        loggedInUser,
        assignedAccountNumber,
        'Clicked Submit to submit multiple Edit Card changes and Card Status update.',
        { selectedCard: request.cards }
      );
    }
  }

  useEffect(() => {
    dispatch(setCurrentMultiEditFormValues(controller.defaultValues));
  }, [controller.defaultValues]);

  function onForwardSubmit() {
    const isLastCard = index === totalCards - 1;
    if (isLastCard) {
      mutliEditConfirmModal.open();
    } else dispatch(incrementMultiEditIndex());
  }

  return (
    <>
      {isLoadingDetails && <Loading />}
      {!isLoadingDetails && (
        <Form
          id={MULTI_EDIT_CARD_MODAL_FORM_ID}
          schema={controller.validationSchema}
          defaultValues={currentFormValues}
          onChange={controller.onFormChange}
          onSubmit={onForwardSubmit}
          memoizeDefaultValues={false}
        >
          <CardModalAccount />
          <CardModal.Details />
          <CardModal.DeliveryAddress />
          <CardModal.UsageOptions />
          <CardModal.ProductsAndServices />
        </Form>
      )}
    </>
  );
}

export default MultiEditCardModalContent;
